// src/pages/SettingsScreen.js
import React from 'react';
import { supabase } from '../lib/supabase';
import { useApp } from '../lib/AppContext';
import { t } from '../lib/i18n';
import { COUNTRY_CONFIG } from '../lib/currency';

export default function SettingsScreen() {
  const { lang, country, user, setCountry, showToast } = useApp();

  const handleCountryChange = async (code) => {
    await setCountry(code, user?.id);
    showToast('Language & currency updated', 'success');
  };

  const handlePasswordChange = async () => {
    const { error } = await supabase.auth.resetPasswordForEmail(user.email, {
      redirectTo: `${window.location.origin}/reset-password`,
    });
    if (error) showToast(error.message, 'error');
    else showToast('Password reset email sent!', 'success');
  };

  return (
    <div style={{ maxWidth: 600, margin:'0 auto', padding:'32px 24px' }}>
      <h2 style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:'1.8rem', letterSpacing:'.05em', marginBottom:28 }}>{t('settings', lang)}</h2>

      <div style={{ marginBottom:28 }}>
        <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:'.72rem', fontWeight:700, letterSpacing:'.2em', textTransform:'uppercase', color:'#4cca74', marginBottom:12 }}>
          {t('language_currency', lang)}
        </div>
        <div style={{ background:'#111', borderRadius:16, border:'1px solid rgba(255,255,255,.07)', overflow:'hidden' }}>
          {Object.entries(COUNTRY_CONFIG).map(([code, cfg]) => {
            const active = country === code;
            return (
              <button key={code} onClick={() => handleCountryChange(code)} style={{ width:'100%', display:'flex', alignItems:'center', justifyContent:'space-between', padding:'14px 18px', background: active ? 'rgba(76,202,116,.08)' : 'none', border:'none', borderBottom:'1px solid rgba(255,255,255,.04)', cursor:'pointer' }}>
                <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                  <span style={{ fontSize:'1.2rem' }}>{cfg.flag}</span>
                  <span style={{ fontFamily:"'Barlow',sans-serif", fontSize:'.9rem', color: active ? '#f4f4f4' : '#888' }}>{cfg.name}</span>
                </div>
                <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                  <span style={{ fontSize:'.75rem', color:'#555', fontFamily:"'Barlow Condensed',sans-serif", fontWeight:700 }}>{cfg.currency}</span>
                  {active && <span style={{ color:'#4cca74' }}>✓</span>}
                </div>
              </button>
            );
          })}
        </div>
        <p style={{ fontSize:'.72rem', color:'#444', marginTop:8, lineHeight:1.7 }}>
          Display currency is cosmetic only. All payments are always charged in EUR by Mollie.
        </p>
      </div>

      <div style={{ marginBottom:28 }}>
        <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:'.72rem', fontWeight:700, letterSpacing:'.2em', textTransform:'uppercase', color:'#4cca74', marginBottom:12 }}>Security</div>
        <button onClick={handlePasswordChange} style={{ width:'100%', background:'#111', border:'1px solid rgba(255,255,255,.07)', borderRadius:12, padding:'14px 18px', display:'flex', justifyContent:'space-between', alignItems:'center', cursor:'pointer' }}>
          <span style={{ fontFamily:"'Barlow',sans-serif", fontSize:'.9rem', color:'#ddd' }}>Change Password</span>
          <span style={{ color:'#4cca74', fontSize:'.85rem' }}>Send reset email</span>
        </button>
      </div>

      <div>
        <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:'.72rem', fontWeight:700, letterSpacing:'.2em', textTransform:'uppercase', color:'#4cca74', marginBottom:12 }}>{t('privacy', lang)}</div>
        {[['Terms & Conditions','/legal/terms'],['Privacy Policy','/legal/privacy'],['Cookie Policy','/legal/cookies'],["Collector's Disclaimer",'/legal/disclaimer']].map(([label, path]) => (
          <button key={path} onClick={() => window.open(path, '_blank')} style={{ width:'100%', background:'#111', border:'none', borderBottom:'1px solid rgba(255,255,255,.04)', display:'flex', alignItems:'center', justifyContent:'space-between', padding:'14px 18px', cursor:'pointer' }}>
            <span style={{ fontFamily:"'Barlow',sans-serif", fontSize:'.9rem', color:'#888' }}>{label}</span>
            <span style={{ color:'#444' }}>›</span>
          </button>
        ))}
      </div>
    </div>
  );
}
